module.exports = __webpack_public_path__ + "static/media/bws1__.33dcb180.svg";